import React, { useState } from 'react';
import PropTypes from 'prop-types';

const CdsFiltersContext = React.createContext();

export default CdsFiltersContext;

const CdsFiltersContextProvider = ({
  children,
  initialLengthOfTerm,
  initialMinDeposit,
  initialMinRatings,
}) => {
  const [filters, setFilters] = useState({
    deposit_minimum: initialMinDeposit,
    length_of_term: initialLengthOfTerm,
    min_ratings: initialMinRatings,
  });

  return (
    <CdsFiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </CdsFiltersContext.Provider>
  );
};

CdsFiltersContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialLengthOfTerm: PropTypes.number,
  initialMinDeposit: PropTypes.number,
  initialMinRatings: PropTypes.string,
};

CdsFiltersContextProvider.defaultProps = {
  initialLengthOfTerm: 12,
  initialMinDeposit: 25000,
  initialMinRatings: '3',
};

export { CdsFiltersContextProvider };
